import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { rem } from '../utilities/style';

const Container = styled.div`
  padding: ${rem(24)} 0;
`;

const ButtonBlock = ({ children, className }) => (
  <Container className={className}>
    {children}
  </Container>
);

ButtonBlock.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string
};

// Convert to styled component so we can reference it in other component styles
export default styled(ButtonBlock)();
